/**
 * Actions exchanged with the IntelliCatch widget. The widget declares the same strings in its own
 * ChildMessageAction, and the two are a wire contract: changing one without the other silently
 * stops the message being handled, with nothing to fail against.
 */
export enum IntelliCatchMessageAction {
  Initialize = 'initialize',
  CopilotLimit = 'intellicatch:copilotLimit',
  ServiceError = 'intellicatch:serviceError',
  GenerationFailed = 'intellicatch:generationFailed',
  SetItemContext = 'intellicatch:setItemContext',
  ClearItemContext = 'intellicatch:clearItemContext',
  ResetConversation = 'intellicatch:resetConversation',
  SetCreateAvailability = 'intellicatch:setCreateAvailability',
  CreateNode = 'intellicatch:createNode',
  CreateNodesBulk = 'intellicatch:createNodesBulk',
  CreateResult = 'intellicatch:createResult',
  GenerationState = 'intellicatch:generationState',
  AttachmentChanged = 'intellicatch:attachmentChanged',
}
